(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RelationshipTypeDialogController', RelationshipTypeDialogController);

    RelationshipTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RelationshipType'];

    function RelationshipTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RelationshipType) {
        var vm = this;
        vm.relationshipType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:relationshipTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.relationshipType.id !== null) {
                RelationshipType.update(vm.relationshipType, onSaveSuccess, onSaveError);
            } else {
                RelationshipType.save(vm.relationshipType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
